import {styled} from 'external/material'
import useTranslations from 'hooks/translations'
import { centerVertically } from 'utils/style'

const StyledDashboardMessage = styled('div')(dashboardMessageStyles)

export default function DashboardMessage(props) {
    
    const {date, title, message = 'Message'} = props
    const {formatDate} = useTranslations()

    return(
        <StyledDashboardMessage className='dashboard-message'>
            <div className='top-row'>
                <div className='date'>{formatDate(date)}</div>
                {title && <div className='title'>{title}</div>}
            </div>
            <div className='content-row'>
                <div className='content'>{message}</div>
            </div>
        </StyledDashboardMessage>
    )
}

function dashboardMessageStyles(){
    return {
        display: 'flex',
        flexDirection: 'column',
        '& > .top-row': {
            flexShrink: 0,
            display: 'flex',
            color: '#2c75bd',
            '& .date': {
                flexShrink: 0,
            },
            '& .title': {
                '&::before': {
                    content: "'- '"
                },
                flexGrow: 1,
                marginLeft: 7 
            }
        },
        '& .content-row': {
            flexGrow: 1,
            ...centerVertically,
            color: '#8b919e'
        }
    }
}
